import { ChipColor } from "interfaces/typesystem";

// Mapeia os diferentes status para suas respectivas cores de `Chip`
// Usando um Record para garantir que cada status terá um valor de cor válido
const colorBadge: Record<string, ChipColor> = {
  Publicado: "success",
  Cancelado: "error",
  Encerrado: "warning",
  Desativado: "secondary",
  Processamento: "info",
  Pago: "success",
  Cortesia: "info",
  Pendente: "warning",
  waiting: "warning",
  identified: "info",
  approved: "success",
  paid: "success",
  unpaid: "error",
  canceled: "error",
  settled: "primary",
  expired: "secondary",
  CONCLUIDA: "success",
};

// Função que recebe o status e retorna a cor correspondente
// O parâmetro `status` é restrito às chaves do objeto `colorBadge` para evitar erros
const getcolorBadge = (status: string): ChipColor => colorBadge[status];

export { getcolorBadge };
